module.exports = __webpack_public_path__ + "static/media/logo.c5a51b17.svg";